import { render, staticRenderFns } from "./Yuqingfengxiandu.vue?vue&type=template&id=3d54766a&scoped=true&"
import script from "./Yuqingfengxiandu.vue?vue&type=script&lang=js&"
export * from "./Yuqingfengxiandu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54766a",
  null
  
)

export default component.exports